/** Small focus helpers shared by panels, sheets and menus. */

const FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

export function focusables(root: HTMLElement): HTMLElement[] {
  return [...root.querySelectorAll<HTMLElement>(FOCUSABLE)].filter((el) => !el.closest('[inert]') && !el.hidden);
}

/**
 * Makes everything outside `el` inert (not clickable, not focusable, hidden from screen readers), for a
 * full-screen panel, up to `boundary` (default: the whole page). Returns the undo; elements that were
 * inert before stay inert.
 */
export function inertOthers(el: HTMLElement, boundary: Element = document.body): () => void {
  const changed: Element[] = [];
  for (let node: Element = el; node.parentElement && node !== boundary && node !== document.body; node = node.parentElement) {
    for (const sibling of node.parentElement.children) {
      if (sibling === node || sibling.hasAttribute('inert') || sibling.tagName === 'SCRIPT') continue;
      sibling.setAttribute('inert', '');
      changed.push(sibling);
    }
  }
  return () => changed.forEach((s) => s.removeAttribute('inert'));
}

/** Keeps Tab / Shift+Tab inside `root` (call from its keydown). */
export function trapTab(root: HTMLElement, e: KeyboardEvent): void {
  if (e.key !== 'Tab') return;
  const list = focusables(root);
  if (list.length === 0) return;
  const first = list[0]!;
  const last = list[list.length - 1]!;
  const active = document.activeElement;
  if (e.shiftKey && (active === first || !root.contains(active))) {
    e.preventDefault();
    last.focus();
  } else if (!e.shiftKey && (active === last || !root.contains(active))) {
    e.preventDefault();
    first.focus();
  }
}
